import React, { ReactNode } from 'react'
// import TopbarSearch from './TopbarSearch'
import TopbarLanguages from './TopbarLanguages'
import TopbarUser from './TopbarUser'
import TopbarLogin from './TopbarLogin'
import TopbarMenu from './TopbarMenu'
import { AuthContext } from "../../../../AuthContext";
import './TopbarBase.scss'
interface Props {
	menu: { title: string, titleEn: string, url: string }[]
}
class TopbarBase extends React.Component<Props> {
	static contextType = AuthContext
	get authenticated() {
		return this.context.authenticated
	}

	render(): ReactNode {
		return (
			<div className="kt-header__topbar">
				<TopbarMenu menu={this.props.menu} />
				{/* <TopbarSearch /> */}
				<TopbarLanguages />
				{
					this.authenticated ? <TopbarUser /> : <TopbarLogin />
				}
			</div>
		)
	}
}

export default TopbarBase
